import { render, staticRenderFns } from "./RenewalsDue.vue?vue&type=template&id=01375ef4&"
import script from "./RenewalsDue.vue?vue&type=script&lang=js&"
export * from "./RenewalsDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports